<template>
  <v-flex pa-1 :class="'xs12 sm12 md' + large_screen_width + ' lg' + large_screen_width + ' xl' + large_screen_width">
    <v-card>
        <div class="text-xs-center pt-2 pb-3">
          <h3 class="pb-2">{{ title }}</h3>
          <v-spacer></v-spacer>
          <div v-for="(item, index) in items" :key="index">
            <div v-if="item.data"><v-icon small v-if="item.type == 'electricity'" color="blue">fa-bolt</v-icon><v-icon small v-if="item.type == 'gas'" color="#ff7a00">fa-fire</v-icon> {{item.data[item.attribute]}} {{ item.unit }} <span v-if="item.data[item.attribute + '_costs']"> = {{ item.data[item.attribute + '_costs'] | currency }}</span></div>
            <!-- <div v-if="current_energy_use.gas"><v-icon color="#00aaff">fa-fire</v-icon> {{current_energy_use.gas.current_flow}} m3/uur = {{current_energy_use.gas.current_flow_wattage}} Watt</div> -->
          </div>
          <div v-if="items.length == 1">&nbsp;</div>
        </div>
      <!-- TODO pulsating ring see telegram<font-awesome-icon icon="circle" :style="{ color: '#000000' }" /> -->
    </v-card>
  </v-flex>
</template>

<script lang="ts">
export default {
  components: {
  },
  props: ['title', 'large_screen_width', 'items'],
  data: function() {
    return {
    }
  }
}
</script>
